module.exports = __webpack_public_path__ + "img/hafiz.b7db1fbc.png";